import { VintageProductModel as AdminVintageProductModel } from "@vini-wine/admin-core-models";
import { VintageProductModel as OfferVintageProductModel } from "@vini-wine/offer-core-models";
import { VintageProductModel as AnalyticVintageProductModel } from "@vini-wine/analytic-core-models";

type VintageProductModels =
  | AdminVintageProductModel
  | OfferVintageProductModel
  | AnalyticVintageProductModel;
export const getVintageProductNameConvention = (
  vintageProduct: VintageProductModels,
): string => {
  const vintageProductVintage = vintageProduct.vintage;
  const vintageProductVintageWine = vintageProductVintage?.wine;
  const vintageProductVintageWineRegion = vintageProductVintage?.wine?.region;
  let vintageProductVintageWineRegionCountry = undefined;
  if (
    vintageProductVintageWineRegion &&
    "country" in vintageProductVintageWineRegion
  ) {
    vintageProductVintageWineRegionCountry =
      vintageProductVintageWineRegion.country;
  }

  const wineryName = vintageProductVintageWine?.winery?.name;
  const wineName = vintageProductVintageWine?.name;
  const wineTypeName = vintageProductVintageWine?.wineType?.name;
  const vintageYear = vintageProductVintage?.year;
  // size units formatter here
  const regionName = vintageProductVintageWineRegion?.name;
  const countryName = vintageProductVintageWineRegionCountry
    ? `, ${vintageProductVintageWineRegionCountry.name}`
    : "";
  return `${wineryName} ${wineName} ${wineTypeName} ${vintageYear} size, ${regionName}${countryName}`;
};
